import { useTranslation } from 'react-i18next';
export default function ComparisonHero({ competitor, headline, subheadline, maxOsTagline, competitorTagline }) {
  const { t } = useTranslation();
  return (
    <section className="relative overflow-hidden border-b border-zinc-900 bg-black" aria-labelledby="comparison-hero-heading">
      <div className="absolute inset-0 grid-bg opacity-40" aria-hidden="true" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#09090B]" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 pt-20 pb-16">
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500 mb-6" aria-hidden="true">
          // COMPARISON
        </div>

        <h1 id="comparison-hero-heading" className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.95] text-white mb-6">
          Max OS Cloud
          <br />
          <span className="text-zinc-400">vs</span>{" "}
          {competitor}
        </h1>

        <p className="text-2xl sm:text-3xl font-display text-amber-500 uppercase leading-tight mb-4">
          {headline}
        </p>

        <p className="max-w-2xl text-lg text-zinc-400 leading-relaxed mb-10">
          {subheadline}
        </p>

        {/* Split layout badges */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl">
          <div className="border-2 border-amber-500 bg-amber-500/5 p-6">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-8 h-8 bg-amber-500 flex items-center justify-center font-display text-black text-lg">M</div>
              <span className="font-display text-white uppercase tracking-tight">{t('comparison_hero.max_os_cloud')}</span>
            </div>
            <p className="text-zinc-400 text-sm">{maxOsTagline}</p>
          </div>

          <div className="border border-zinc-700 bg-zinc-950/50 p-6">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-8 h-8 bg-zinc-700 flex items-center justify-center font-display text-zinc-400 text-lg">
                {competitor.charAt(0)}
              </div>
              <span className="font-display text-zinc-300 uppercase tracking-tight">{competitor}</span>
            </div>
            <p className="text-zinc-500 text-sm">{competitorTagline}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
